module.exports = __webpack_public_path__ + "static/media/BackgroundSOS_Tunstall.93218bbb.png";